import { Spacing } from "./spacing.es.js";
const BorderRadius = {
  none: 0,
  soft: Spacing["125"],
  brand: Spacing["500"],
  paper: Spacing["750"],
  full: "100%"
};
export {
  BorderRadius
};
//# sourceMappingURL=border-radius.es.js.map
